import React from "react";
import { toTimestamp } from "./formatters";

const CHAT_READERS_DATE_FORMATTER = new Intl.DateTimeFormat("ru-RU", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});
const CHAT_READERS_TIME_FORMATTER = new Intl.DateTimeFormat("ru-RU", {
  hour: "2-digit",
  minute: "2-digit",
});
export const CHAT_ADMIN_ROLE_CODES = new Set(["OWNER", "HOST", "CREATOR", "ADMIN", "MODERATOR"]);
export const CHAT_HOST_ROLE_CODES = new Set(["OWNER", "HOST", "CREATOR"]);
export const CHAT_PSYCHOLOGIST_ROLE_CODES = new Set(["PSYCHOLOGIST"]);

export function normalizeRoleCode(value) {
  if (value == null) return "";
  return String(value).trim().toUpperCase();
}

export function toUserId(value) {
  const id = Number(value);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function normalizeSearchUser(raw) {
  if (!raw || typeof raw !== "object") return null;
  const id = toUserId(raw.id ?? raw.userId ?? raw.user_id ?? raw.memberId ?? raw.member_id);
  if (!id) return null;

  const nameRaw =
    raw.fullName ??
    raw.full_name ??
    raw.name ??
    raw.displayName ??
    raw.display_name ??
    raw.username ??
    raw.userName ??
    raw.user_name ??
    raw.email ??
    raw.phone ??
    "";

  const name = String(nameRaw || "").trim() || `Пользователь ${id}`;

  const avatarUrl =
    raw.avatarUrl ??
    raw.avatar_url ??
    raw.avatar ??
    raw.photoUrl ??
    raw.photo_url ??
    raw.user?.avatarUrl ??
    raw.user?.avatar_url ??
    raw.user?.avatar ??
    raw.user?.photoUrl ??
    "";

  return {
    id,
    name,
    avatarUrl: avatarUrl ? String(avatarUrl) : "",
    roleCode: normalizeRoleCode(raw.role ?? raw.userRole ?? raw.user_role ?? raw.memberRole ?? raw.member_role),
  };
}

export function CheckIcon({ read }) {
  if (read) {
    return (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polyline points="1 12 5 16 12 6" />
        <polyline points="7 12 11 16 20 6" />
      </svg>
    );
  }

  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="2 12 7 17 20 4" />
    </svg>
  );
}

export function extractMessageReaders(raw) {
  const list = Array.isArray(raw)
    ? raw
    : Array.isArray(raw?.items)
    ? raw.items
    : Array.isArray(raw?.content)
    ? raw.content
    : Array.isArray(raw?.readers)
    ? raw.readers
    : Array.isArray(raw?.data?.items)
    ? raw.data.items
    : Array.isArray(raw?.data?.content)
    ? raw.data.content
    : Array.isArray(raw?.data)
    ? raw.data
    : [];

  return list
    .map((item, index) => {
      if (!item || typeof item !== "object") return null;

      const userId =
        item.readerUserId ??
        item.reader_user_id ??
        item.userId ??
        item.user_id ??
        item.id ??
        item.reader?.id ??
        null;

      const nameRaw =
        item.readerName ??
        item.reader_name ??
        item.fullName ??
        item.full_name ??
        item.name ??
        item.userName ??
        item.user_name ??
        item.reader?.fullName ??
        item.reader?.name ??
        item.reader?.userName ??
        item.reader?.email ??
        "";

      const name = String(nameRaw || "").trim() || (userId != null ? `Пользователь ${userId}` : `Пользователь ${index + 1}`);

      return {
        userId: userId == null ? null : String(userId),
        name,
        readAt:
          item.readAt ??
          item.read_at ??
          item.seenAt ??
          item.seen_at ??
          item.createdAt ??
          item.created_at ??
          item.timestamp ??
          null,
      };
    })
    .filter(Boolean)
    .sort((a, b) => toTimestamp(b?.readAt) - toTimestamp(a?.readAt));
}

export function formatReaderReadAt(value) {
  const ts = toTimestamp(value);
  if (!ts) return "Время не указано";
  const date = new Date(ts);
  return `${CHAT_READERS_DATE_FORMATTER.format(date)} ${CHAT_READERS_TIME_FORMATTER.format(date)}`;
}

